import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { CARDS_TYPE } from '../../enums/cardTypes';
import win from '../../assets/images/png-icons/win.png';
import push from '../../assets/images/png-icons/push.png';
import lose from '../../assets/images/png-icons/close-black.png';
import bust from '../../assets/images/png-icons/star-black.png';
import double from '../../assets/images/png-icons/x2.png';
import surrender from '../../assets/images/png-icons/flag-new.png';
import blackJack from '../../assets/images/png-icons/bj.png';
import plus from '../../assets/images/png-icons/min_plus.png';
import minus from '../../assets/images/png-icons/min-minus.png';
// import { gameStore } from '../../store/gameStore';

const CurrentHandCards = observer(
  ({
    handInfo,
    isActive,
    isRoundFin,
    isAnimationOn,
    cardsTotalPoint,
    selectedCardType,
    playerCardsByHands,
    selectedCardBackSideType,
  }) => {
    // const { splitBetId } = gameStore;
    const showIconSrc = useMemo(() => {
      if (handInfo.isPush) {
        return push;
      }
      if (handInfo.isWin) {
        return win;
      }
      if (handInfo.isBust) {
        return bust;
      }
      if (handInfo.isLose) {
        return lose;
      }
      if (handInfo.isDouble) {
        return double;
      }
      if (handInfo.isSurrender) {
        return surrender;
      }
      if (handInfo.isBlackJack) {
        return blackJack;
      }
      if (handInfo.isHit) {
        return plus;
      }
      if (handInfo.isStand) {
        return minus;
      }

      return null;
    }, [handInfo]);

    // const currentUserBets = bets.filter((bet) => +bet.userId === +userId);
    // false 'toggleTimer' 44129 'splitBetId' true 'isStand'

    // const cardsToDisplay =
    //   !handInfo.isHandActive
    //     ? playerCardsByHands.slice(0, 2)
    //     : playerCardsByHands;

    // const isActive = useMemo(() => Boolean((betId || splitBetId) || !isBetsClosed), [betId, splitBetId]);

    return (
      <div
        className={`${isMobile() ? 'm-' : ''}card-player-panel-inner ${isActive ? '' : 'disabled'}`}
      >
        {showIconSrc && (
          <div className={`${isMobile() ? 'm-' : ''}player-action-block`}>
            <img src={showIconSrc} alt='Show' />
          </div>
        )}
        {cardsTotalPoint && (
          <p
            className={`${isMobile() ? 'm-' : ''}counter-num-block player ${
              handInfo.isHandActive ? 'full-bg' : ''
            } ${handInfo.isWin ? 'win' : ''} ${handInfo.isPush ? 'push' : ''} ${
              handInfo.isLose ? 'lose' : ''
            }`}
          >
            <span className={`${isMobile() ? 'm-' : ''}counter-num-block-txt`}>
              {cardsTotalPoint.point}
              {cardsTotalPoint.secondPoint && !handInfo.isStand && !isRoundFin
                ? `/${cardsTotalPoint.secondPoint}`
                : ''}
            </span>
          </p>
        )}
        <div className={`${isMobile() ? 'm-' : ''}inside-card-player-panel-inner`}>
          {playerCardsByHands.map(({ card, index, isDouble, showCard }) => {
            if (showCard) {
              return (
                <div
                  className={`${isMobile() ? 'm-' : ''}player-card-wrapper ${
                    isAnimationOn ? '' : 'no-animation'
                  } ${isDouble ? 'double' : ''}`}
                  key={index}
                >
                  <div className={`${isMobile() ? 'm-' : ''}blackjack-card card-open`}>
                    <div
                      className={`${
                        isMobile() ? 'm-' : ''
                      }blackjack-card-front-side ${selectedCardType} ${CARDS_TYPE[card]} `}
                    />
                    <div
                      className={`${
                        isMobile() ? 'm-' : ''
                      }blackjack-card-back-side ${selectedCardBackSideType}`}
                    />
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  }
);

export default CurrentHandCards;
